import http from '@/http';

export async function updatePagePart(id, data) {
  return await http.put(`/admin/page-parts/${id}`, data).then((res) => res.data);
}
